/*
    This component chooses appropriate image to load

    HTML structure:

    <div class="js-imageController">
        <div class="js-imageController__option" data-src="{string}" data-retina={boolean} data-display-from={integer} data-display-to={integer}>
        ...
    </div>

    If you would like use this component for swiper lazy laod, add class swiper-lazy.

    <div class="js-imageController swiper-lazy">...</div>
*/

Bingo.ImageController = {};

Bingo.ImageController.init = function (id) {
    let entity;
    if (id === undefined) {
        entity = $('.js-imageController');
    } else {
        entity = $(`#${id}`).find('.js-imageController');
    }
    entity.each(function () {
        const options = [];
        $(this).find('.js-imageController__option').each(function () {
            const option = {
                retina: $(this).data('retina'),
                minWidth: $(this).data('display-from') || 0,
                maxWidth: $(this).data('display-to') || 9999,
                src: $(this).data('background'),
            };
            options.push(option);
        });
        const retina = window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 144dpi)').matches;
        const windowWidth = window.innerWidth;
        const result = options.filter(option => option.retina === retina && windowWidth > option.minWidth && windowWidth < option.maxWidth);
        $(this).attr('data-background', result[0].src);
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if ($(this).hasClass('swiper-lazy') && !isIE11) {
            $(this).css('data-background', `url(${result[0].src})`);
        } else {
            $(this).css('background-image', `url(${result[0].src})`);
        }
    });
    $(this).removeClass('js-imageController');
};
